import React, { useEffect } from "react";

import { t } from "i18next";

import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

const SiteMap = ({ handleChange, value }) => {
	const [linkUrl, setLinkUrl] = React.useState(value?.linkUrl || "");

	useEffect(() => {
		setLinkUrl(value?.linkUrl || "");
	}, [value]);

	const handleUrlChange = e => {
		const { value } = e.target;
		setLinkUrl(value);
		if (handleChange) {
			handleChange("linkUrl", value);
		}
	};

	return (
		<>
			<Typography>{t("sitemap.insert_link")}</Typography>
			<TextField
				fullWidth
				label={t("sitemap.insert_url")}
				value={linkUrl}
				onChange={handleUrlChange}
				variant="outlined"
			/>
		</>
	);
};

export default SiteMap;
